import type { HomePage } from '~/api'

export const usePageStore = defineStore('page', () => {
  const api = useApi()

  const directoryStore = useDirectoryStore()
  const { regionId } = storeToRefs(directoryStore)

  const mainPage = ref<HomePage | null>(null)

  const fetchMainPage = async () => {
    if (!regionId.value) return

    mainPage.value = (
      await api.public.home({
        region_id: regionId.value,
      })
    ).data
  }

  watch(regionId, () => {
    if (regionId.value) {
      fetchMainPage()
    }
  })

  return {
    mainPage,

    fetchMainPage,
  }
})
